<div
  class="offcanvas offCanvasStart offcanvas-start bg-light"
  tabindex="-1"
  id="legend"
  aria-labelledby="legend"
>
  <div class="offcanvas-header">
    <div class="w-100">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="mb-0 me-3">{{ mapServiceName }} Legend</h2>
        <button
          type="button"
          class="btn btn-secondary btn-icon-only"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="offcanvas-body">
    <div class="overflow-hidden w-100" id="legendScrollContainerTop">
      <div class="legend-wrapper">
        <img [src]="legendImageSrc" class="img-fluid" [alt]="layerName" />
      </div>
    </div>
  </div>
</div>
